import React, { useCallback, useEffect, useState } from 'react';
import { App, Badge, Button, ColorPicker, Form, Input, Modal, Space, Table, Tag, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { hataMesaji, markaApi } from './markaApi';
import MarkaDuzenle from './MarkaDuzenle';

const { Text } = Typography;

/** Marka listesi + yeni marka; bir marka seçilince MarkaDuzenle. */
export default function MarkaYonetimi({ onOnizle, onDegisti }) {
  const { message } = App.useApp();
  const [markalar, setMarkalar] = useState(null);
  const [secili, setSecili] = useState(null);
  const [yeniAcik, setYeniAcik] = useState(false);
  const [form] = Form.useForm();

  const yukle = useCallback(async () => {
    try { setMarkalar((await markaApi.markalar()).markalar); } catch (e) { message.error(hataMesaji(e), 6); }
  }, [message]);
  useEffect(() => { yukle(); }, [yukle]);

  const degisti = () => { yukle(); onDegisti?.(); };

  const ekle = async () => {
    const d = await form.validateFields();
    try {
      await markaApi.ekle({ ...d, renk_ana: typeof d.renk_ana === 'string' ? d.renk_ana : d.renk_ana.toHexString().toUpperCase() });
      message.success('Marka taslak olarak açıldı');
      setYeniAcik(false); form.resetFields(); degisti(); setSecili(d.slug);
    } catch (e) { message.error(hataMesaji(e), 6); }
  };

  if (secili) {
    return <MarkaDuzenle slug={secili} onGeri={() => { setSecili(null); yukle(); }} onOnizle={onOnizle} onDegisti={degisti} />;
  }

  return (
    <div>
      <Space style={{ marginBottom: 12 }}>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => setYeniAcik(true)}>Yeni marka</Button>
        <Text type="secondary">Yeni marka taslak açılır; logolar ve dosyalar yüklenip "Yayınla" denince portalda görünür.</Text>
      </Space>
      <Table size="small" rowKey="slug" loading={!markalar} dataSource={markalar || []} pagination={false}
        onRow={(r) => ({ onClick: () => setSecili(r.slug), style: { cursor: 'pointer' } })}
        columns={[
          { title: 'Sıra', dataIndex: 'sira', width: 60 },
          {
            title: 'Marka', dataIndex: 'ad',
            render: (ad, r) => <Space><span style={{ display: 'inline-block', width: 14, height: 14, borderRadius: 3, background: r.renk_ana }} />{ad}<Text type="secondary">({r.slug})</Text></Space>,
          },
          { title: 'Durum', dataIndex: 'durum', width: 90, render: (d) => (d === 'yayinda' ? <Tag color="green">Yayında</Tag> : <Tag color="orange">Taslak</Tag>) },
          { title: 'Logo düzeni', dataIndex: 'logo_sayisi', width: 100 },
          { title: 'Dosya', dataIndex: 'dosya_sayisi', width: 80 },
          {
            title: 'Kontrol', width: 200,
            render: (_, r) => (
              <Space>
                {r.zorunlu_eksik > 0 ? <Badge status="error" text={`${r.zorunlu_eksik} zorunlu eksik`} /> : <Badge status="success" text="Zorunlular tamam" />}
                {r.uyari > 0 && <Text type="secondary">{r.uyari} uyarı</Text>}
              </Space>
            ),
          },
          { title: 'Güncellendi', dataIndex: 'guncellenmeTarihi', width: 170, render: (t) => (t ? String(t).replace('T', ' ').slice(0, 16) : '—') },
        ]} />

      <Modal open={yeniAcik} title="Yeni marka" onCancel={() => setYeniAcik(false)} onOk={ekle} okText="Taslak olarak aç">
        <Form form={form} layout="vertical" initialValues={{ renk_ana: '#000000' }}>
          <Form.Item name="ad" label="Görünen ad" rules={[{ required: true, whitespace: true }]}><Input placeholder="ATMPOINT" /></Form.Item>
          <Form.Item name="slug" label="Kısa ad" extra="Küçük harf, rakam ve tire; dosya yollarında kullanılır ve sonradan değiştirilemez."
            rules={[{ required: true }, { pattern: /^[a-z0-9][a-z0-9-]{1,38}$/, message: 'Küçük harf, rakam ve tire (2–39 karakter)' }]}>
            <Input placeholder="atmpoint" />
          </Form.Item>
          <Form.Item name="renk_ana" label="Ana renk" rules={[{ required: true }]}><ColorPicker disabledAlpha showText format="hex" /></Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
